import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getAlertsCount, getOpenTicketsCount } from 'store/groups/service';

export const initialState: INotificationsState = {
  tableRefreshNotice: false,
  socket: null,
  alertsCount: 0,
  alertsCountLoading: false,
  openTicketsCount: 0,
  openTicketsCountLoading: false
};

const slice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setTableRefreshNotice: (state, action: PayloadAction<boolean>) => {
      state.tableRefreshNotice = action.payload;
    },
    incrementAlertsCount: (state) => {
      state.alertsCount++;
    },
    decrementAlertsCount: (state) => {
      if (state.alertsCount) state.alertsCount--;
    },
    setSocket: (state, action: PayloadAction<any>) => {
      state.socket = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAlertsCount.pending, (state, action: PayloadAction<any>) => {
      state.alertsCountLoading = true;
    });
    builder.addCase(getAlertsCount.fulfilled, (state, action: PayloadAction<any>) => {
      state.alertsCountLoading = false;
      state.alertsCount = Number(action.payload?.tally?.medical);
    });
    builder.addCase(getOpenTicketsCount.pending, (state, action: PayloadAction<any>) => {
      state.openTicketsCountLoading = true;
    });
    builder.addCase(getOpenTicketsCount.fulfilled, (state, action: PayloadAction<any>) => {
      state.openTicketsCountLoading = false;
      state.openTicketsCount = Number(action.payload) || 0;
    });
    builder.addCase(getOpenTicketsCount.rejected, (state, action: PayloadAction<any>) => {
      state.openTicketsCountLoading = false;
      state.openTicketsCount = 0;
    });
  }
});

export const { setTableRefreshNotice, incrementAlertsCount, setSocket, decrementAlertsCount } =
  slice.actions;
export const notificationsReducer = slice.reducer;
